import React from "react";
import { TrendingBucket } from "../../../api/analyticsAdmin";
import { deltaInfo } from "../../../helpers/searchTrending";
import { queryLabel } from "../../../helpers/searchAnalytics";
import { formatInteger } from "../../../helpers/formatNumber";
import DeltaBadge from "./DeltaBadge";

const TrendingNow: React.FC<{
  bucket: TrendingBucket;
  label: string;
  nounLabel?: string;
  valueLabel?: string;
}> = ({ bucket, label, nounLabel = "Query", valueLabel = "Searches" }) => (
  <div className="bg-white rounded-lg shadow overflow-hidden">
    <div className="px-4 py-3 text-sm text-gray-500 border-b border-gray-100">
      {label}
    </div>
    <table className="w-full text-sm">
      <thead className="bg-gray-50 text-gray-500">
        <tr>
          <th className="text-left font-medium px-4 py-3 w-12">#</th>
          <th className="text-left font-medium px-4 py-3">{nounLabel}</th>
          <th className="text-right font-medium px-4 py-3">{valueLabel}</th>
          <th className="text-right font-medium px-4 py-3">Movement</th>
        </tr>
      </thead>
      <tbody>
        {bucket.items.map((item) => (
          <tr key={item.query} className="border-t border-gray-100">
            <td className="px-4 py-3 text-gray-400">{item.rank}</td>
            <td className="px-4 py-3">{queryLabel(item)}</td>
            <td className="px-4 py-3 text-right">
              {formatInteger(item.searches)}
            </td>
            <td className="px-4 py-3 text-right">
              <DeltaBadge info={deltaInfo(item)} />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default TrendingNow;
